import { useState } from 'react';
import Box from '@mui/material/Box';
import Modal from '../../componentsv2/Modal';
import { useTranslation } from '../../hooks/i18n';
import Step1ValidateTwoFAAndGenerateNewRecoveryCode from './components/Step1ValidateTwoFAAndGenerateNewRecoveryCode';
import Step2DownloadNewRecoveryCode from './components/Step2DownloadNewRecoveryCode';

interface GenerateRecoveryCodeModalProps {
  isOpen: boolean;
  handleClose: () => void;
}

const GenerateRecoveryCodeModal = ({ isOpen, handleClose }: GenerateRecoveryCodeModalProps) => {
  const { t } = useTranslation();
  const [currentStep, setCurrentStep] = useState(0);
  const [recoveryCode, setRecoveryCode] = useState<string | null>(null);

  const onClose = () => {
    handleClose();
  };

  const onGenerateNewRecoveryCode = (newRecoveryCode: string) => {
    setRecoveryCode(newRecoveryCode);
    setCurrentStep(1);
  };

  const renderStep = () => {
    switch (currentStep) {
      case 0:
        return (
          <Step1ValidateTwoFAAndGenerateNewRecoveryCode
            onGenerateNewRecoveryCode={onGenerateNewRecoveryCode}
            t={t}
          />
        );
      case 1:
        return <Step2DownloadNewRecoveryCode recoveryCode={recoveryCode!} handleFinish={onClose} t={t} />;
      default:
        return null;
    }
  };

  return (
    <Modal isOpen={isOpen} handleClose={handleClose} size="large" isAutoHeight>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          width: '100%',
          height: '100%',
        }}
      >
        {renderStep()}
      </Box>
    </Modal>
  );
};

export default GenerateRecoveryCodeModal;
